import React, { useEffect, useState } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import { getDefaultValue } from './formControl';
import { isFormValid } from 'common/utils/validator';
import Select from 'b2b-ui-components-lib/lib/components/select';
import { fetchCityStateList } from 'common/services/http.service';
import { isOrderConfirmationUrl, prepareOptionsForDropDown } from 'dedicated/services/summary.service';

import './index.scss';
import { ORDER_TYPE } from 'common/constants/app.constants';
import { addressRegexValidator } from 'common/utils/app.utils';

const ShippingDetails = ({ order, updateParentForm, setFormStatus, formData, isOrderConfirmation }) => {
  const [cityList, setCityList] = useState([]);
  const [form, setForm] = useState(getDefaultValue(order));

  const onPinCodeChange = (value) => setForm({ ...form, pinCode: { ...form.pinCode, value, touched: true, errors: form.pinCode.validator(value) } });
  const onaddressChange = (value) => {
    // console.log(value, 'akash');
    if ((value.length >= 1 && value[value.length - 1] === '') || addressRegexValidator(value)) {
      setForm({ ...form, address: { ...form.address, value, touched: true, errors: form.address.validator(value) } });
    }
  };
  // const onaddressChange = (value) => setForm({ ...form, address: { ...form.address, value, touched: true, errors: form.address.validator(value) } });
  const onCityChange = (value) => setForm({ ...form, city: { ...form.city, value, touched: true } });
  const setShippingForm = ({ pinCode, city, address, checked }) => {
    setForm({
      ...form,
      pinCode: {
        ...form.pinCode,
        value: pinCode
      },
      city: {
        ...form.city,
        value: city
      },
      address: {
        ...form.address,
        value: address
      },
      selected: checked
    });
  };

  const onCheckBoxChange = (checked) => {
    const billingDetails = formData.billingDetails;

    if (checked) {
      setShippingForm({
        pinCode: billingDetails?.pinCode?.value,
        city: billingDetails?.city?.value,
        address: billingDetails?.address?.value,
        checked: true
      });
    } else {
      setShippingForm({
        pinCode: '',
        city: '',
        address: '',
        checked: false
      });
    }
  };

  const isCheckBoxDisabled = () => {
    if (formData.billingDetails?.pinCode?.value && formData.billingDetails?.city?.value && formData.billingDetails?.address?.value) {
      return false;
    }

    return true;
  };

  const resetCityAddress = () => {
    setForm({ ...form, city: { ...form.city, value: '', touched: true }, address: { ...form.address, value: '', touched: true } });
  };

  const onFieldBlur = (formElement, keyName) => {
    const { value, validator, errors: existingError } = formElement;
    let errors = [];
    if (typeof validator === 'function') {
      errors = validator(value);
    }
    setForm({ ...form, [keyName]: { ...form[keyName], value, errors: errors.concat(existingError), touched: true } });
  };

  // const isOrderConfirmationPending = () => {
  //   return order.orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING;
  // };

  const isDisabled = () => {
    return isOrderConfirmationUrl() || isOrderConfirmation;
  };

  useEffect(() => {
    if (form.pinCode.errors.length === 0 && form.pinCode.value) {
      resetCityAddress();
      fetchCityStateList(form.pinCode.value).then(
        ({ data: { result } }) => {
          if (Array.isArray(result)) {
            setForm({
              ...form,
              pinCode: { ...form.pinCode, touched: true, errors: [] },
              city: { ...form.city, value: '', touched: true },
              address: { ...form.address, value: '', touched: true }
            });
            const cityList = prepareOptionsForDropDown(result, 'city');
            setCityList(cityList);
            if (cityList.length === 1) {
              onCityChange(cityList[0]);
            }
          }
        },
        (err) => {
          let errMsg = err && err.response && err.response.data && err.response.data.errorMsg;
          setCityList([]);
          setForm({
            ...form,
            pinCode: { ...form.pinCode, touched: true, errors: [errMsg ? errMsg : 'Please enter valid Pincode'] },
            city: { ...form.city, value: '', touched: true },
            address: { ...form.address, value: '', touched: true }
          });
          console.error(err);
        }
      );
    }
  }, [form.pinCode.value]);

  useEffect(() => {
    const keyToIgnore = ['touched', 'selected'];
    if (isFormValid(form, keyToIgnore)) {
      updateParentForm({ shippingDetails: form });
      setFormStatus((formStatus) => ({
        ...formStatus,
        shippingDetails: true
      }));
    } else {
      updateParentForm({ shippingDetails: null });
      setFormStatus((formStatus) => ({
        ...formStatus,
        shippingDetails: false
      }));
    }
  }, [form]);

  useEffect(() => {
    if (form.selected) {
      setShippingForm({
        pinCode: '',
        city: '',
        address: '',
        checked: false
      });
    }
  }, [formData.billingDetails?.pinCode?.value, formData.billingDetails?.city?.value, formData.billingDetails?.address?.value]);

  return (
    <div className="shipping_details form_area">
      <h6>Shipping Details</h6>
      <Checkbox checked={form.selected} onChange={onCheckBoxChange} disabled={isCheckBoxDisabled() || isDisabled()}>
        <span className="check_text">Shipping details same as billing details</span>
      </Checkbox>
      <div className="row field_row">
        <div className="flg-lg-12 flg-md-12">
          <div className="row">
            <div className="flg-lg-6 flg-md-6">
              <Input
                label="Shipping Address Pin Code"
                maxlength={6}
                value={form.pinCode.value ? form.pinCode.value : ''}
                isValidChange={(value) => /^(\s*|\d+)$/.test(value)}
                onBlur={() => onFieldBlur(form.pinCode, 'pinCode')}
                required
                errors={form.pinCode.errors}
                touched={form.pinCode.touched}
                onChange={onPinCodeChange}
                disabled={isDisabled()}
              />
            </div>
            <div className="flg-lg-6 flg-md-6">
              <Select label="Shipping Address City" value={form.city.value} onChange={onCityChange} options={cityList} placeholder="City" required disabled={isDisabled()} />
            </div>
          </div>
          <div className="row">
            <div className="flg-lg-12">
              <TextArea
                label="Shipping Address"
                maxlength={250}
                required
                value={form.address.value}
                onBlur={() => onFieldBlur(form.address, 'address')}
                errors={form.address.errors}
                touched={form.address.touched}
                onChange={onaddressChange}
                disabled={isDisabled()}
              />
            </div>
            <div style={{ position: 'relative' }}>
              <small id="helpId" className="help-text-counter">
                {(form.address.value && form.address.value.length) || 0} /250
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingDetails;
